import React, { useState } from "react";
import { motion } from "framer-motion";
import { Flame, Wine } from "lucide-react";
import Modal, { Ext } from "./Modal";

const alcohol = [
  {
    name: "Alcohol etílico",
    modal: (
      <>
        <p><strong>Clasificación arancelaria:</strong> NC 2207</p>
        <p><strong>Impuesto especial:</strong> 830,25 €/hl de alcohol puro (Tarifa 1ª, grupo I)</p>
        <p><strong>Exenciones:</strong> alcohol desnaturalizado para uso industrial (art. 42 Ley 38/1992), uso farmacéutico (art. 43), fabricación de vinagre (art. 42.1.d)</p>
        <h4>Usos habituales</h4>
        <ul>
          <li>Trading a granel entre depósitos fiscales UE</li>
          <li>Importación desde terceros países para envasado en España</li>
          <li>Suministro a industria alimentaria, cosmética o farmacéutica</li>
        </ul>
        <p><Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-1992-26834">Ley 38/1992, arts. 74-76</Ext></p>
      </>
    ),
  },
  {
    name: "Bebidas espirituosas",
    modal: (
      <>
        <p><strong>Clasificación arancelaria:</strong> NC 2208 (whisky, gin, vodka, ron, brandy)</p>
        <p><strong>Impuesto especial:</strong> 10,18 €/litro de alcohol puro (Tarifa 1ª, grupo III)</p>
        <h4>Operaciones habituales</h4>
        <ul>
          <li>Importación intracomunitaria desde destilerías europeas</li>
          <li>Importación desde terceros países con DUA</li>
          <li>Reexpedición a Estados Miembros sin liquidar IIEE en España</li>
        </ul>
        <p>
          <Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-1992-26834">Ley 38/1992, art. 79</Ext>
          {" · "}
          <Ext href="https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX%3A32008R0110">Reglamento CE 110/2008</Ext>
        </p>
      </>
    ),
  },
  {
    name: "Brandy y coñac",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2208.20 (aguardiente de vino o de orujo)</p>
        <p><strong>Denominaciones de Origen:</strong> Brandy de Jerez (DO), Cognac (AOC Francia)</p>
        <p><Ext href="https://eur-lex.europa.eu/legal-content/ES/TXT/?uri=CELEX%3A32019R0787">Reglamento UE 2019/787 (bebidas espirituosas)</Ext></p>
      </>
    ),
  },
  {
    name: "Licores",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2208.70</p>
        <p><strong>Requisito:</strong> mínimo 15% vol. de alcohol</p>
        <h4>Operaciones</h4>
        <ul>
          <li>Producción en depósito fiscal</li>
          <li>Adquisición intracomunitaria</li>
          <li>Distribución interna</li>
        </ul>
      </>
    ),
  },
  {
    name: "Alcohol industrial",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2207.20 (alcohol desnaturalizado)</p>
        <p><strong>Exención:</strong> no sujeto al IIEE cuando está correctamente desnaturalizado</p>
        <h4>Usos</h4>
        <ul>
          <li>Productos de limpieza</li>
          <li>Cosméticos</li>
          <li>Pinturas, disolventes</li>
        </ul>
        <p>Normativa: art. 42.1.a) Ley 38/1992</p>
      </>
    ),
  },
  {
    name: "Alcohol farmacéutico y cosmético",
    modal: (
      <>
        <p><strong>Base legal:</strong> art. 43 Ley 38/1992 (exenciones para uso médico y farmacéutico)</p>
        <p><strong>Condiciones:</strong> autorización específica de la Oficina Gestora, trazabilidad completa.</p>
        <h4>Usos</h4>
        <ul>
          <li>Fabricación de medicamentos</li>
          <li>Perfumería de lujo</li>
          <li>Productos sanitarios</li>
        </ul>
      </>
    ),
  },
];

const hidrocarburos = [
  {
    name: "Gasolina",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.12</p>
        <p><strong>Impuesto:</strong> 400,69 €/1.000 litros (sin plomo 95)</p>
        <p>
          <Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-1992-26834">Ley 38/1992, arts. 46-57</Ext>
          {" · "}
          <Ext href="https://www.boe.es/buscar/act.php?id=BOE-A-1998-23284">Ley 34/1998</Ext>
        </p>
      </>
    ),
  },
  {
    name: "Gasóleo / Gasoil",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.19</p>
        <h4>Tipos impositivos</h4>
        <ul>
          <li>Gasóleo automoción (A): 307,00 €/1.000 litros</li>
          <li>Gasóleo calefacción (C): 78,71 €/1.000 litros</li>
          <li>Gasóleo agrícola (B): tipo bonificado — gestión especial</li>
        </ul>
        <p>Ley 38/1992, art. 54</p>
      </>
    ),
  },
  {
    name: "Queroseno",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.19.21 / 2710.19.25</p>
        <p><strong>Uso aviación (JET A-1):</strong> tipo 0 en vuelos internacionales (exención).</p>
      </>
    ),
  },
  {
    name: "Aceites lubricantes",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.19.71 a 2710.19.99</p>
        <p><strong>Impuesto:</strong> 45,80 €/1.000 litros</p>
      </>
    ),
  },
  {
    name: "Asfaltos y betunes",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2713</p>
        <p><strong>Tipo:</strong> 9,00 €/1.000 kg</p>
        <p><strong>Sector:</strong> obra civil e infraestructuras.</p>
      </>
    ),
  },
  {
    name: "Fueloil pesado",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.19.51 a 2710.19.68</p>
        <p><strong>Tipo:</strong> 14,00 €/1.000 kg</p>
        <p><strong>Uso:</strong> generación eléctrica, industria naval.</p>
      </>
    ),
  },
  {
    name: "Nafta",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2710.12.11 a 2710.12.19</p>
        <p><strong>Uso:</strong> materia prima petroquímica e industria química.</p>
      </>
    ),
  },
  {
    name: "Butano y propano",
    modal: (
      <>
        <p><strong>Clasificación:</strong> NC 2711 (GLP)</p>
        <p><strong>Tipo:</strong> 57,47 €/1.000 kg (uso general)</p>
        <p>Ley 38/1992, art. 50 bis</p>
      </>
    ),
  },
];

const Block = ({ Icon, title, accent, items, testid, onItemClick }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6 }}
    data-testid={testid}
    className="relative bg-gradient-to-br from-[#1E3A5F]/50 to-[#0A1628]/40 backdrop-blur-md border border-white/10 rounded-3xl p-8 md:p-10 overflow-hidden"
  >
    <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full blur-3xl" style={{ backgroundColor: `${accent}30` }} />
    <div className="relative flex items-center gap-4 mb-8">
      <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ backgroundColor: accent }}>
        <Icon className="w-7 h-7 text-white" strokeWidth={1.7} />
      </div>
      <h3 className="text-2xl md:text-3xl font-bold text-white" style={{ fontFamily: "Poppins" }}>
        {title}
      </h3>
    </div>
    <div className="relative grid grid-cols-2 gap-3">
      {items.map((p, idx) => (
        <button
          type="button"
          key={p.name}
          onClick={() => onItemClick(idx)}
          data-testid={`product-${testid}-${idx}`}
          className="text-left flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3 hover:bg-white/10 hover:border-[#0066FF] cursor-pointer transition-all"
        >
          <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ backgroundColor: accent }} />
          <span className="text-slate-200 text-sm">{p.name}</span>
        </button>
      ))}
    </div>
  </motion.div>
);

export const Products = () => {
  const [open, setOpen] = useState(null); // { group, idx }
  const current = open ? (open.group === "alcohol" ? alcohol[open.idx] : hidrocarburos[open.idx]) : null;
  const eyebrow = open ? (open.group === "alcohol" ? "Alcohol y Bebidas Derivadas" : "Hidrocarburos") : "";
  return (
    <section
      id="productos"
      data-testid="products-section"
      className="relative bg-[#0A1628] py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl"
        >
          <span className="text-xs uppercase tracking-[0.25em] text-[#FF6B00] font-semibold">
            Productos
          </span>
          <h2
            className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight"
            style={{ fontFamily: "Poppins" }}
          >
            Operamos con productos sujetos a impuestos especiales.
          </h2>
          <p className="mt-5 text-slate-300 text-lg">
            Dos grandes familias dentro del régimen suspensivo IIEE.
          </p>
        </motion.div>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          <Block
            Icon={Wine}
            title="Alcohol y Bebidas Derivadas"
            accent="#0066FF"
            items={alcohol}
            testid="products-block-alcohol"
            onItemClick={(idx) => setOpen({ group: "alcohol", idx })}
          />
          <Block
            Icon={Flame}
            title="Hidrocarburos"
            accent="#FF6B00"
            items={hidrocarburos}
            testid="products-block-hidrocarburos"
            onItemClick={(idx) => setOpen({ group: "hidrocarburos", idx })}
          />
        </div>
      </div>

      {current && (
        <Modal open={!!current} onClose={() => setOpen(null)} title={current.name} eyebrow={eyebrow}>
          {current.modal}
        </Modal>
      )}
    </section>
  );
};

export default Products;
